import React, { useEffect,useRef } from 'react'
import { Grid } from '@mui/material'
import { Heading, MainContainer,TokenGrid,ImgGrid,Text,Value,ImgDiv,Symbol,ContractGrid,ContractDiv,ContractColumn,IconImg,IconDiv,
    LeftImg,Div,RightImg} from './style'
import AOS from 'aos';
import Community  from '../../Components/LockerMenu/community/community';


const Tokenomics = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, // Adjust this threshold as needed
      };
  
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Element is visible, add the classes with delay to trigger the move-out effect
            setTimeout(() => {
              entry.target.classList.add('move-out-left');
            }, 1000); // 3 seconds delay for the left image
  
            setTimeout(() => {
              entry.target.classList.add('move-out-right');
            }, 1000); // 3 seconds delay for the right image
          } else {
            // Element is not visible, remove the classes to reset the position
            entry.target.classList.remove('move-out-left');
            entry.target.classList.remove('move-out-right');
          }
        });
      };
  
      const observer = new IntersectionObserver(callback, options);
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
  
      return () => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      };
    }, []);
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    },[]);
  return (
    <Div>
    <MainContainer maxWidth="xxl"  id="tokenomics">
        <Grid container ref={sectionRef} className="image-container">
            <Grid item xs={6}>
                <div ><LeftImg src="./assets/left-img.png" className="image-left"/></div>
            </Grid>
            <Grid item xs={6}>
                <div ><RightImg src="./assets/right-img.png" className="image-right"/></div>
            </Grid>
        </Grid>
        <Grid container>
            <TokenGrid container item xs={12}>
                <Heading>Tokenomics</Heading>
                <ImgGrid item xs={6} sm={2.5} md={1.7} lg={1.5} xl={1}>
                    <ImgDiv>
                        <img src="./assets/Img-1.png" />
                    </ImgDiv>
                        <Text>Supply</Text>
                        <Value style={{fontSize:'21px'}}>5,000,000,000,000</Value>
                </ImgGrid>
                <ImgGrid item xs={6} sm={2.5} md={1.7} lg={1.5} xl={1}>
                    <ImgDiv>
                        <img src="./assets/Img-2.png" />
                    </ImgDiv>
                        <Text>Taxes</Text>
                        <Value style={{fontSize:'21px'}}>1/1</Value>
                </ImgGrid>
                <ImgGrid item xs={6} sm={2.5} md={1.7} lg={1.5} xl={1}>
                    <ImgDiv>
                        <img src="./assets/Img-3.png" />
                    </ImgDiv>
                        <Text>Lp Locked</Text>
                        <Value style={{fontSize:'21px'}}>3 Months</Value>
                </ImgGrid>
                <ImgGrid item xs={6} sm={2.5} md={1.7} lg={1.5} xl={1}>
                    <ImgDiv>
                        <img src="./assets/Img-4.png" />
                    </ImgDiv>
                        <Text>Renounced</Text>
                        <Value style={{fontSize:'21px'}}>Post Launch</Value>
                </ImgGrid>
            </TokenGrid>
        </Grid>
        <ContractGrid container>
            <ContractColumn item xs={12} sm={6.5} md={6} lg={5} xl={3}>
                <Symbol>Symbol</Symbol>
                <img src="./assets/gear5.png" />
                <ContractDiv>
                    <Text>Contract</Text><Text>TBA</Text>
                </ContractDiv>
                <IconDiv>
                    <IconImg src="./assets/ether.png" />
                    <IconImg src="./assets/uni.png" />
                    <IconImg src="./assets/dex.png" />
                </IconDiv>
            </ContractColumn>
        </ContractGrid>
    </MainContainer>
    <Community />
    </Div>
  )
}

export default Tokenomics
